import React from 'react';
import { FormField } from 'components/FormField/FormField';
import { PDropdown } from 'components/prime/PDropdown/PDropdown';
import { useCodeframesModalBLoC } from '../../CodeframesModal.bloc';

export const CodeframesModalType: React.FC = () => {
  const { form, isEditCodeframe } = useCodeframesModalBLoC();

  return (
    <FormField
      form={form}
      controller={{
        name: 'type',
        rules: {
          required: !isEditCodeframe && 'Type is required',
        },
      }}
      label="Type"
    >
      {({ field, fieldState }) => (
        <PDropdown
          {...field}
          options={[
            {
              label: 'Thematic',
              value: 'thematic',
            },
            {
              label: 'Recall',
              value: 'recall',
            },
          ]}
          placeholder="Select a type"
          invalid={fieldState.invalid}
          disabled={isEditCodeframe}
        />
      )}
    </FormField>
  );
};
